import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, DollarSign } from 'lucide-react';
import { BUYBACK_BANNERS } from '../data/buybackBanners';

// "We Buy" promotional banner gallery for /sell and all buyback pages.
export const BuybackBanners = ({
  className = '',
  theme = 'dark',
  title = 'We Buy It All \u2014 Get Cash Today',
  subtitle = 'Sealed or used, top dollar paid. Fast, easy, and local at our Chicago walk-in store.',
}) => {
  const light = theme === 'light';
  return (
    <section className={`max-w-6xl mx-auto px-4 sm:px-6 my-12 ${className}`} data-testid="buyback-banners">
      <div className="text-center mb-7">
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold mb-3 ${light ? 'bg-emerald-100 text-emerald-700' : 'bg-emerald-500/15 text-emerald-400'}`}>
          <DollarSign className="w-3.5 h-3.5" /> TOP DOLLAR PAID
        </div>
        <h2 className={`text-2xl sm:text-3xl font-extrabold ${light ? 'text-slate-900' : 'text-white'}`}>{title}</h2>
        <p className={`text-sm mt-2 max-w-2xl mx-auto ${light ? 'text-slate-600' : 'text-slate-400'}`}>{subtitle}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-5">
        {BUYBACK_BANNERS.map((b, i) => (
          <figure
            key={b.src}
            data-testid={`buyback-banner-${i}`}
            className={`group overflow-hidden rounded-2xl border shadow-lg ${light ? 'border-slate-200 bg-white' : 'border-slate-800 bg-slate-900'} ${i === 4 ? 'col-span-2 md:col-span-1' : ''}`}
          >
            <div className="relative aspect-square overflow-hidden">
              <img
                src={b.src}
                alt={b.alt}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <figcaption className={`px-3 py-2.5 ${light ? 'bg-white' : 'bg-slate-900'}`}>
              <p className={`text-sm font-bold leading-tight ${light ? 'text-slate-900' : 'text-white'}`}>{b.title}</p>
              <p className={`text-xs mt-0.5 ${light ? 'text-slate-500' : 'text-slate-400'}`}>{b.tagline}</p>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="text-center mt-7">
        <Link
          to="/sell"
          data-testid="buyback-banners-cta"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-sm transition-colors shadow-lg shadow-emerald-500/20"
        >
          Get My Instant Cash Offer <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
};

export default BuybackBanners;
